module.exports = __webpack_public_path__ + "media/entities/5201-26fa3bcf.png";